import React, { useEffect, useState } from 'react';
import Chart from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { Row, Card, Col, CardBody, CardHeader, Container } from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import randomColor from 'randomcolor';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../assets/styles/table_custom_style';
import {
  chartOptions,
  parseOptions,
  chartExample2,
  chartExample6
} from 'variables/charts.js';
const Synthetic = (props) => {
  const [barChartData, setBarChartData] = useState(null);
  const [pieChartData, setPieChartData] = useState(null);

  useEffect(() => {
    if (window.Chart) parseOptions(Chart, chartOptions());

    if (props.list && props.typeReport === 2)
      if (props.list.length > 0) {
        let arrayLabels = [];
        let arrayData = [];
        let colorsData = [];

        props.list.forEach((data) => {
          let name =
            data.callDisposition === 'ANSWERED' ? 'Atendida' : 'Não Atendida';
          arrayLabels.push(name);
          arrayData.push(data.quantity);
          colorsData.push(randomColor({ hue: 'green' }));
        });

        setBarChartData({
          labels: [...arrayLabels],
          datasets: [
            {
              data: [...arrayData],
              maxBarThickness: 50,
              backgroundColor: [...colorsData]
            }
          ]
        });
        setPieChartData({
          labels: [...arrayLabels],
          datasets: [
            {
              data: [...arrayData],
              backgroundColor: [...colorsData]
            }
          ]
        });
      }
  }, [props.list, props.typeReport]);

  return (
    <>
      <Row>
        <div className="col">
          <div className="card-wrapper">
            <Card>
              <ToolkitProvider
                data={props.showReports}
                keyField="uuid"
                columns={[
                  {
                    dataField: 'status',
                    text: 'Status da Chamada',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'quantity',
                    text: 'Quantidade',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'tma',
                    text: 'Tempo médio de Atendimento',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'tta',
                    text: 'Tempo total de atendimento',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  }
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  </div>
                )}
              </ToolkitProvider>

              <Container fluid>
                {pieChartData && barChartData && (
                  <Row>
                    <Col xl="12">
                      <Card>
                        <CardHeader>
                          <h6 className="surtitle">Visão Geral</h6>
                          <h5 className="h3 mb-0">
                            Quantidade de Chamadas por Status
                          </h5>
                        </CardHeader>
                        <CardBody>
                          <Row>
                            <Col xl="6">
                              <div className="chart">
                                <Pie
                                  data={pieChartData}
                                  options={chartExample6.options}
                                  className="chart-canvas"
                                  id="chart-pie"
                                />
                              </div>
                            </Col>
                            <Col xl="6">
                              <div className="chart">
                                <Bar
                                  data={barChartData}
                                  options={chartExample2.options}
                                  className="chart-canvas"
                                  id="chart-bars"
                                />
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                )}
              </Container>
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
};
export default Synthetic;
